export default class CacheService {
    storeCache(cacheName, arr) {
        return new Promise((resolve) => {
            caches.open(cacheName).then(function (cache) {
                return cache.addAll(arr).then(() => resolve());
            });
        });
    }

    deleteCache(cacheName) {
        return new Promise((resolve) => {
            caches.delete(cacheName).then(() => resolve());
        });
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/cache.js